export default __webpack_public_path__ + "static/media/amazon.c0fb3bc6.jpg";